<template>
   <navBack></navBack>
   <view class="customer-edit">
        <!-- 页面标题 -->
        <view class="page-header">
            <text class="page-title">{{ isEdit ? '编辑客户' : '新增客户' }}</text>
        </view>

        <!-- 客户信息表单 -->
        <view class="form-section">
            <t-cell-group>
                <!-- 客户姓名 -->
                <t-cell title="客户姓名" required>
                    <template #note>
                        <t-input v-model="customerForm.name" placeholder="请输入客户姓名" maxlength="20" />
                    </template>
                </t-cell>

                <!-- 手机号码 -->
                <t-cell title="手机号码" required>
                    <template #note>
                        <t-input v-model="customerForm.mobile" type="number" placeholder="请输入手机号码" maxlength="11" />
                    </template>
                </t-cell>

                <!-- 性别 -->
                <t-cell title="性别">
                    <template #note>
                        <t-radio-group v-model="customerForm.gender" placement="horizontal">
                            <t-radio value="1">男</t-radio>
                            <t-radio value="2">女</t-radio>
                        </t-radio-group>
                    </template>
                </t-cell>

                <!-- 生日 -->
                <t-cell title="生日">
                    <template #note>
                        <t-date-picker v-model="customerForm.birthday" mode="date" format="YYYY-MM-DD">
                            <template #trigger>
                                <view class="date-trigger">
                                    {{ customerForm.birthday || '请选择生日' }}
                                </view>
                            </template>
                        </t-date-picker>
                    </template>
                </t-cell>

                <!-- 客户来源 -->
                <t-cell title="客户来源">
                    <template #note>
                        <t-picker v-model="customerForm.source" :columns="sourceOptions" @change="onSourceChange">
                            <template #trigger>
                                <view class="picker-trigger">
                                    {{ getSourceText(customerForm.source) || '请选择客户来源' }}
                                </view>
                            </template>
                        </t-picker>
                    </template>
                </t-cell>

                <!-- 备注 -->
                <t-cell title="备注">
                    <template #note>
                        <t-textarea v-model="customerForm.remark" placeholder="请输入备注信息"
                            :autosize="{ minRows: 3, maxRows: 6 }" />
                    </template>
                </t-cell>
            </t-cell-group>
        </view>

        <!-- 操作按钮 -->
        <view class="action-section">
            <t-button block theme="primary" :disabled="!canSubmit" @click="saveCustomer">
                保存
            </t-button>
            <t-button v-if="isEdit" block theme="danger" variant="outline" style="margin-top: 20px;"
                @click="showConfirmDialog=true">
                删除客户
            </t-button>
        </view>
    </view>


    <t-dialog v-model:visible="showConfirmDialog" title="请确认" content="确定要删除该客户吗？" cancel-btn="取消" confirm-btn="确认"
        @confirm="deleteCustomer" @cancel="showConfirmDialog = false">
    </t-dialog>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Toast } from 'tdesign-mobile-vue';
import navBack  from '@/components/nav-back.vue'
// 路由相关
const router = useRouter()
const route = useRoute()

const showConfirmDialog = ref(false);

// 响应式数据
const isEdit = ref(false)
const customerForm = ref({
    name: '',
    mobile: '',
    gender: '1',
    birthday: '',
    source: '',
    remark: ''
})

// 客户来源选项
const sourceOptions = ref([
    { label: '朋友推荐', value: '1' },
    { label: '网络搜索', value: '2' },
    { label: '线下活动', value: '3' },
    { label: '其他', value: '4' }
])

// 计算属性：是否可以提交
const canSubmit = computed(() => {
    return customerForm.value.name && customerForm.value.mobile
})

// 获取客户来源文本
const getSourceText = (value) => {
    const option = sourceOptions.value.find(item => item.value === value)
    return option ? option.label : ''
}

// 客户来源变更
const onSourceChange = (value) => {
    customerForm.value.source = value
}

// 保存客户信息
const saveCustomer = async () => {
    if (!canSubmit.value) {

        Toast('请填写必填信息');
        return
    }

    try {
        // 这里应该调用实际的API保存客户信息
        if (isEdit.value) {
            // 更新客户信息
            console.log('更新客户信息:', customerForm.value)
        } else {
            // 新增客户信息
            console.log('新增客户信息:', customerForm.value)
        }
        Toast('保存成功');


        // 返回上一页
        setTimeout(() => {
            router.back()
        }, 1000)
    } catch (error) {


        Toast('保存成功');

    }
}

// 删除客户
const deleteCustomer = () => {



    Toast('删除成功');

    showConfirmDialog.value = false;
    router.back()
}

// 加载客户信息
const loadCustomerInfo = async () => {
    try {
        // 这里应该调用实际的API获取客户信息
        // 示例数据
        customerForm.value = {
            name: '张三',
            mobile: '13800138000',
            gender: '1',
            birthday: '1990-01-01',
            source: '1',
            remark: '重要客户'
        }
    } catch (error) {
        console.error('加载客户信息失败:', error)
    }
}

// 组件挂载时初始化数据
onMounted(() => {
    // 检查是否有客户ID，判断是编辑还是新增
    const customerId = route.query.id
    if (customerId) {
        isEdit.value = true
        loadCustomerInfo(customerId)
    }
})
</script>

<style scoped>
.customer-edit {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 40px;
}

.page-header {
    background-color: #fff;
    padding: 30rpx 20px;
    border-bottom: 1rpx solid #eee;
}

.page-title {
    font-size: 36px;
    font-weight: bold;
    color: #333;
}

.form-section {
    margin: 20rpx 0;
    background-color: #fff;
}

.date-trigger,
.picker-trigger {
    color: #999;
    padding: 20rpx 0;
}

.action-section {
    padding: 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
}
</style>